define(function (require) {

    var BaseTableWidgetsManager = require('web-agent-framework/BaseTableWidgetsManager');
    var VisitorListEngagementWidget = require('web-agent-widgets/VisitorListEngagementWidget');

    var VisitorsListWidgetsManager = BaseTableWidgetsManager.extend({
        ControllerName: 'VisitorsListWidgetsManager',
        applicationType: 'VisitorsListWidgetsManager',

        LPViewMap: {
        },

        initialize: function (constructorData) {
        },

        events: function () {
        },

        render: function () {
        }
    });

    /**
     * This method will be invoked when the selected item in the list will be changed.
     * It's purpose it to determine which widgets should be visible for the newly selected item.
     * since it overrides the "onSelectedItemChanged" in "BaseTableWidgetsManager", it calls it as the first action performed.
     * @param data
     */
    VisitorsListWidgetsManager.prototype.onSelectedItemChanged = function (data) {
        BaseTableWidgetsManager.prototype.onSelectedItemChanged.call(this, data);
        var itemData = data.newValue.eventData;
        if (itemData && itemData[this.itemIdTag]) {
            if (this[VisitorListEngagementWidget.applicationType]) {
                if (lpTag.WebAgent.logicController.visitorHasChat(itemData) &&
                    lpTag.WebAgent.logicController.agentCanViewChat(itemData)) {
                    this.showWidgetContainer(VisitorListEngagementWidget.applicationType);
                } else {
                    this.hideWidgetContainer(VisitorListEngagementWidget.applicationType);
                }
            }
        }
    };

    return VisitorsListWidgetsManager;

});
